var map = {
	"./slogan1.png": 21428,
	"./slogan2.png": 43887,
	"./slogan3.png": 58790,
	"./slogan4.png": 63769,
	"./slogan5.png": 48016,
	"./slogan6.png": 13419,
	"./slogan7.png": 49762,
	"./slogan8.png": 50629,
	"./slogan_bg1.png": 67438,
	"./slogan_bg2.png": 78917
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 59726;